const SEARCH__RESULT_PAGE_CLASSES_PREFIX = "searchResultsPage";

export const SEARCH_RESULTS_PAGE_CLASSES = {
  header: `${SEARCH__RESULT_PAGE_CLASSES_PREFIX}-header`,
  counter: `${SEARCH__RESULT_PAGE_CLASSES_PREFIX}-counter`,
  tabsWrapper: `${SEARCH__RESULT_PAGE_CLASSES_PREFIX}-tabsWrapper`,
  tab: `${SEARCH__RESULT_PAGE_CLASSES_PREFIX}-tab`,
  content: `${SEARCH__RESULT_PAGE_CLASSES_PREFIX}-content`,
  active: `${SEARCH__RESULT_PAGE_CLASSES_PREFIX}-active`,
};

export const DEFAULT_TEST_AUTOMATION_ID = "search-results-page";
